var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", { staticClass: "list-item talent-list-item" }, [
    _c("div", { staticClass: "talent-list-item__container" }, [
      _vm.user.profile_image_url
        ? _c("div", { staticClass: "talent-list-item__image" }, [
            _c("img", { attrs: { src: _vm.user.profile_image_url } }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "talent-list-item__copy" }, [
        _c("h4", { staticClass: "truncate h4" }, [
          _vm._v("\n        " + _vm._s(_vm.user.name) + "\n        "),
          _vm.user.profile &&
          _vm.user.profile.visibility === "hidden" &&
          (_vm.$userIsAdmin || _vm.$userIsManager)
            ? _c("i", {
                staticClass: "fa fa-eye-slash text-grey",
                attrs: { "aria-label": "hidden", title: "hidden" },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.user.profile &&
          _vm.user.profile.visibility === "private" &&
          (_vm.$userIsAdmin || _vm.$userIsManager)
            ? _c("i", {
                staticClass: "fa fa-lock text-grey",
                attrs: { "aria-label": "private", title: "private" },
              })
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "w-full" }, [
          (_vm.$userIsManager || _vm.$userIsAdmin) &&
          _vm.bookingCancelledForUser
            ? _c("div", { staticClass: "label label-danger" }, [
                _vm._v("\n          Cancelled\n        "),
              ])
            : this.user.response &&
              (this.user.response.budget ||
                this.user.response.budget_per_star_as_user_rate)
            ? _c("div", { staticClass: "label label-success" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm._f("currency")(
                        this.user.response.budget
                          ? this.user.response.budget
                          : this.user.response.budget_per_star_as_user_rate,
                        _vm.booking.currency
                      )
                    ) +
                    "\n        "
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "w-full talent-list-item__buttons" },
          [
            _vm.showViewBio
              ? _c(
                  "router-link",
                  {
                    staticClass: "btn btn-primary-outline btn-sm",
                    attrs: {
                      tag: "a",
                      to: {
                        name: "talent.profile.view",
                        params: { id: _vm.user.id, status: "event" },
                      },
                      target: "_blank",
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-user",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(" View Bio\n        "),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.photoIsPresent
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-primary-outline btn-sm",
                    on: { click: _vm.showLightBox },
                  },
                  [
                    _c("lightbox", {
                      key: _vm.lightBoxKey,
                      attrs: {
                        images: _vm.images,
                        showLightBox: _vm.showBox,
                        showCaption: true,
                      },
                    }),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "fa fa-camera",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(" Promo Photos\n        "),
                  ],
                  1
                )
              : !_vm.$userIsClient
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-primary-outline btn-padding btn-sm",
                    attrs: { disabled: "" },
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-camera",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(" No Photos\n        "),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.$paymentsModuleEnabled &&
            _vm.booking.status === "completed" &&
            _vm.$userIsAdmin
              ? _c(
                  "div",
                  [
                    this.user.response &&
                    this.user.response.talent_paid_notif_sent
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-primary-outline btn-padding btn-sm",
                            attrs: { disabled: "" },
                          },
                          [
                            _c("i", { staticClass: "fa fa-envelope" }),
                            _vm._v(" Notify Payment Sent\n          "),
                          ]
                        )
                      : _c(
                          "ladda-button",
                          {
                            staticClass:
                              "btn btn-primary pull-right btn-padding btn-sm",
                            attrs: {
                              click: _vm.handleNotifyTalentPaymentSentCallback,
                            },
                          },
                          [
                            _vm._v("\n            Send Notify Payment "),
                            _c("i", { staticClass: "fa fa-send" }),
                          ]
                        ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }